<template>
	<div>
		<el-card>
			<el-table ref="multipleTable" :data="orderList" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="id" label="订单号" width="200">
				</el-table-column>
				<el-table-column label="购买用户" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="flex-align-center">
							<el-avatar :size="30" :src="scope.row.userInfo.avatar"></el-avatar>
							<span style="margin-left: 5px;">{{scope.row.userInfo.nickname}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="total_money" label="支付金额" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="status" label="状态" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.status == '待付款'" style="color: #ffcc00;">{{scope.row.status}}</span>
						<span v-if="scope.row.status == '待发货'" style="color: red;">{{scope.row.status}}</span>
						<span v-if="scope.row.status == '待收货'" style="color: #33ccff;">{{scope.row.status}}</span>
						<span v-if="scope.row.status == '已取消'" style="color: #999;">{{scope.row.status}}</span>
						<span v-if="scope.row.status == '已完成'" style="color: #00cc66;">{{scope.row.status}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" :formatter="$f.timeFormat" label="下单时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="管理" width="200">
					<template slot-scope="scope">
						<el-button @click="checkExpress(scope.row.id,scope.$index)" v-if="scope.row.status == '待发货'" type="primary">发货</el-button>
						<el-popconfirm v-else confirmButtonText='确定' cancelButtonText='取消' @confirm="orderDel(scope.row.id,scope.$index)"
						 icon="el-icon-info" iconColor="red" title="确定删除？">
							<el-button slot="reference" type="danger">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next"
			 :total="orderLength">
			</el-pagination>
		</el-card>
		<!-- 添加圈子类目弹窗 -->
		<el-dialog title="发货" :visible.sync="dialogFormVisible">
			<el-form :model="form" ref="form">
				<el-form-item label="物流公司">
					<el-select v-model="form.express_company" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :model="form" ref="form">
				<el-form-item label="物流单号">
					<el-input v-model="form.express_number" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="saveExpress">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
				orderList: [],
				multipleSelection: [],
				btnLoading: false,
				btnDisabled: false,
				dialogFormVisible: false,
				form: {
					id: "",
					express_company: "",
					express_number: ""
				},
				checkOrderIndex: "",
				options: [{
						value: 'yuantong',
						label: '圆通速递'
					}, {
						value: 'yunda',
						label: '韵达快递'
					}, {
						value: 'zhongtong',
						label: '中通快递'
					}, {
						value: 'youzhengguonei',
						label: '邮政快递包裹'
					}, {
						value: 'huitongkuaidi',
						label: '百世快递'
					},
					{
						value: 'shunfeng',
						label: '顺丰速运'
					},
					{
						value: 'shentong',
						label: '申通快递'
					},
					{
						value: 'jd',
						label: '京东物流'
					}
				],
				currentPage: 1,
				pagesize: 0,
				orderLength: 0,
			}
		},
		created() {
			this.getOrderList();
		},
		methods: {
			checkExpress(id, index) {
				this.dialogFormVisible = true;
				this.form.id = id;
				this.checkOrderIndex = index;
			},
			saveExpress() {
				this.$H.post("order/orderExpress", this.form).then(res => {
					if (res.code == 200) {
						this.$message.success(res.msg);
						this.orderList[this.checkOrderIndex].status = "待收货";
						this.dialogFormVisible = false;
					}
				})
			},
			orderDel(id, index) {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("order/del", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.orderList.splice(index, 1);
						this.$message.success(res.msg);
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			getOrderList() {
				this.$H.post("order/list",{
					page: this.currentPage
				}).then(res => {
					this.orderList = res.result.data;
					this.pagesize = res.result.per_page;
					this.orderLength = res.result.total;
				})

			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOrderList();
			}
		}
	}
</script>

<style>
</style>
